<auto-main-navigation [accountId]=""></auto-main-navigation>
<p-panel>
  <p-header>
    <h1>Offer Set Validation</h1>
  </p-header>
  <form [formGroup]="rulesForm">
    <div class="p-d-flex p-justify-end p-mb-3">
      <div class="p-d-flex p-gap-2">
        <button
          pButton
          type="button"
          class="p-button-success"
          label="Add"
          [disabled]="saving"
          (click)="addRule()">
        </button>
        <button
          pButton
          type="button"
          class="p-button-primary p-ml-2"
          label="Save Changes"
          [disabled]="saving || deleting || !rulesForm.valid"
          (click)="saveChanges()">
        </button>
      </div>
    </div>
    <div formArrayName="rules">
      <p-table
        class="custom-table p-datatable-gridlines"
        [value]="rules.controls"
        [loading]="loading"
        [paginator]="true"
        [rows]="25"
        [rowsPerPageOptions]="[25, 50, 100]"
        [scrollable]="true">
        <ng-template pTemplate="header">
          <tr>
            <th>Vehicle Condition</th>
            <th>Data Field</th>
            <th>Operator</th>
            <th>Value</th>
            <th>Enabled</th>
            <th>Created</th>
            <th>Modified</th>
            <th>Action</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rule let-rowIndex="rowIndex">
          <tr [formGroup]="rule">
            <td>
              <p-select
                appendTo="body"
                optionLabel="label"
                optionValue="value"
                placeholder="Select a condition"
                [options]="conditionOptions"
                formControlName="vehicleCondition">
              </p-select>
            </td>
            <td>
              <p-select
                appendTo="body"
                optionLabel="label"
                optionValue="value"
                placeholder="Select a data field"
                [options]="dataFieldOptions"
                formControlName="dataField"
                (onChange)="handleDataFieldChange(rule)">
              </p-select>
              @if (rule.controls.dataField.invalid && rule.controls.dataField.touched) {
                <small class="invalid-text">Data field is required.</small>
              }
            </td>
            <td>
              <p-select
                appendTo="body"
                optionLabel="label"
                optionValue="value"
                placeholder="Select an operator"
                [options]="getOperatorOptions(rule)"
                formControlName="operator">
              </p-select>
              @if (rule.controls.operator.invalid && rule.controls.operator.touched) {
                <small class="invalid-text">Operator is required.</small>
              }
            </td>
            <td>
              <div class="p-inputgroup">
                @if (isCurrencyValue(rule)) {
                  <span class="p-inputgroup-addon">$</span>
                }
                <input
                  pInputText
                  type="number"
                  step="any"
                  formControlName="value"/>
                @if (isPercentValue(rule)) {
                  <span class="p-inputgroup-addon">%</span>
                }
              </div>
              @if (rule.controls.value.invalid && rule.controls.value.touched) {
                <small class="invalid-text">A finite numeric value is required.</small>
              }
            </td>
            <td>
              <p-checkbox [binary]="true" formControlName="enabled"></p-checkbox>
            </td>
            <td>
              @if (rule.controls.created.value) {
                {{ rule.controls.created.value | date:'short':'UTC' }}
              } @else {
                —
              }
            </td>
            <td>
              @if (rule.controls.modified.value) {
                {{ rule.controls.modified.value | date:'short':'UTC' }}
              } @else {
                —
              }
            </td>
            <td>
              <button
                pButton
                type="button"
                class="p-button-danger p-button-icon"
                icon="pi pi-trash"
                aria-label="Delete rule"
                [disabled]="saving || deleting"
                (click)="removeRule(rowIndex)">
              </button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="8"><i>No offer set validation rules found.</i></td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </form>
  <p-confirmDialog key="deleteOfferSetValidationRule"></p-confirmDialog>
</p-panel>
<auto-footer></auto-footer>
